import { Navbar } from "@/components/site/Navbar";
import { OpeningHero } from "@/components/site/OpeningHero";
import { Hero } from "@/components/site/Hero";
import { ScrollStory } from "@/components/site/ScrollStory";
import { TrustStrip } from "@/components/site/TrustStrip";
import { About } from "@/components/site/About";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { Brands } from "@/components/site/Brands";
import { Categories } from "@/components/site/Categories";
import { DealershipCTA } from "@/components/site/DealershipCTA";
import { Advantages } from "@/components/site/Advantages";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { DealerMap } from "@/components/site/DealerMap";
import { Faq } from "@/components/site/Faq";
import { Testimonials } from "@/components/site/Testimonials";
import { useSiteContent } from "@/lib/useSiteContent";

export default function Home() {
  const homeContent = useSiteContent("home");
  const contactContent = useSiteContent("contact");
  const brandsContent = useSiteContent("brands");
  const dealersContent = useSiteContent("dealers");

  const sectionRegistry = [
    { id: "hero", render: () => <Hero content={homeContent} /> },
    { id: "scroll-story", render: () => <ScrollStory content={homeContent} /> },
    { id: "trust-strip", render: () => <TrustStrip content={homeContent} /> },
    { id: "about", render: () => <About content={homeContent} /> },
    { id: "marquee", render: () => <EditorialMarquee content={homeContent} /> },
    { id: "brands", render: () => <Brands content={brandsContent} /> },
    { id: "categories", render: () => <Categories content={homeContent} /> },
    { id: "dealership-cta", render: () => <DealershipCTA content={dealersContent} /> },
    { id: "advantages", render: () => <Advantages content={homeContent} /> },
    { id: "testimonials", render: () => <Testimonials content={homeContent} /> },
    { id: "dealer-map", render: () => <DealerMap /> },
    { id: "faq", render: () => <Faq /> },
    { id: "contact", render: () => <Contact content={contactContent} /> },
  ];
  const layoutById = new Map((homeContent.layout || []).map((item) => [item.id, item]));
  const orderedSections = [
    ...((homeContent.layout || []).filter((item) => sectionRegistry.some((section) => section.id === item.id))),
    ...sectionRegistry.filter((section) => !layoutById.has(section.id)).map(({ id }) => ({ id, visible: true })),
  ];

  return (
    <div className="bg-cream text-ink">
      <Navbar content={{ home: homeContent, contact: contactContent, dealers: dealersContent }} />
      <main>
        <OpeningHero content={homeContent} />
        {orderedSections.filter((item) => item.visible !== false).map((item) => {
          const section = sectionRegistry.find((entry) => entry.id === item.id);
          return <div key={item.id}>{section?.render()}</div>;
        })}
      </main>
      <Footer content={{ home: homeContent, contact: contactContent, dealers: dealersContent }} />
    </div>
  );
}
